import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader, IonIcon,
    IonItem,
    IonPage,
    IonTitle,
    IonToolbar,
    useIonModal
} from "@ionic/react";
import React, {useRef} from "react";
import {openOutline} from "ionicons/icons";
import IpAccessEntityList from "./IpAccessEntityList";

const ModalContent = ({ dismiss, userId, serviceId, readonly }) => {

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => dismiss(null, 'cancel')}>
                            Cancel
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Manage IP Addresses</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IpAccessEntityList userId={userId} serviceId={serviceId} readonly={readonly}></IpAccessEntityList>
            </IonContent>
        </IonPage>
    )
};

export default function ({ionItemLines, access, entityInfoTemplate, onGrantIpAccess, presentLoading, presentToast }) {
    const openModal = () => {
        present({
            onWillDismiss: (event) => {
                if (event.detail.role === 'confirm') {
                    console.log(event.detail.data, event.detail.role);
                    onGrantIpAccess(event.detail.data);
                }
            },
        });
    };

    const [present, dismiss] = useIonModal(ModalContent, {
        userId: access.userId,
        serviceId: access.serviceId,
        readonly: access.isReadOnly,
        dismiss: (data, role) => dismiss(data, role)
    });

    return (
        <IonItem button lines={ionItemLines} key={`access-${access.userId}-${access.serviceId}`} onClick={() => openModal()}>
            {entityInfoTemplate(access)}
            <IonIcon style={{marginRight: '5px'}} icon={openOutline}></IonIcon>
        </IonItem>
    );
}